 <template>
  <div>
    <v-row class="d-flex align-center">
      <v-col cols="3">
        <v-text-field
          v-model.number="selectedYear"
          label="Year"
          type="number"
          dense
          outlined
          hide-details
          :rules="yearRules"
          @input="onYearInput"
          @change="applyFilters"
        />
      </v-col>
      <v-col cols="3" class="pl-4">
        <v-select
          v-model="selectedLocation"
          :items="locations"
          item-text="title"
          item-value="id"
          label="Location"
          dense
          outlined
          hide-details
          @change="applyFilters"
        />
      </v-col>
    </v-row>
  </div>
</template>

<script>
import { mapGetters } from 'vuex';

export default {
  name: 'HolidaysFilters',
  data() {
    const currentYear = new Date().getFullYear();
    return {
      selectedYear: currentYear,
      selectedLocation: null, // будет установлено в watch
      currentYear,
      yearRules: [
        v => !!v || 'Year is required',
        v => /^\d{4}$/.test(String(v)) || 'Year must be a 4-digit number',
        v => {
          const minYear = this.currentYear - 100;
          const maxYear = this.currentYear + 100;
          return (v >= minYear && v <= maxYear) || `Year must be between ${minYear} and ${maxYear}`;
        }
      ],
    };
  },
  computed: {
    ...mapGetters('shared/locations', ['locations']),
  },
  watch: {
    locations: {
      immediate: true,
      handler(newLocations) {
        if (newLocations && newLocations.length) {
          const yaroslavlLocation = newLocations.find(loc => loc.title === 'Yaroslavl');
          if (yaroslavlLocation) {
            this.selectedLocation = yaroslavlLocation.id;
            this.applyFilters();
          }
        }
      }
    }
  },
  methods: {
    applyFilters() {
      if (this.yearRules.every(rule => rule(this.selectedYear) === true)) {
        const filters = {
          year: this.selectedYear,
          location_id: this.selectedLocation,
        };
        this.$emit('filter', filters);
      }
    },
    onYearInput(value) {
      // Удаляем все нецифровые символы
      const numericValue = String(value).replace(/\D/g, '');
      if (numericValue !== String(value)) {
        this.selectedYear = Number(numericValue) || this.selectedYear;
      }
    },
  },
};
</script> 